import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 mb-30" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-items-center justify-content-end"
}
const _hoisted_7 = { class: "d-flex flex-wrap gap-3 justify-content-end ms-auto" }
const _hoisted_8 = { class: "row justify-content-center" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_AlertModal = _resolveComponent("AlertModal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('feature.auth.$delete_account.disclaimer')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createCommentVNode(" SAVE "),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.initRequest()))
                    }, _toDisplayString(_ctx.$t('page.delete_account')), 1 /* TEXT */)
                  ])
                ]))
              : (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 1 }))
          ])
        ])
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_AlertModal, {
      id: "alertModal",
      title: _ctx.$t('feature.auth.delete_account'),
      dismissible: false,
      message: _ctx.$t('feature.auth.$delete_account.success_message'),
      onConfirm: _ctx.redirect
    }, null, 8 /* PROPS */, ["title", "message", "onConfirm"]),
    _createVNode(_component_ConfirmModal, {
      id: "confirmModal",
      title: _ctx.$t('feature.auth.delete_account'),
      message: _ctx.$t('feature.auth.$delete_account.alert_message'),
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendRequest()))
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}